import { useTranslation, Trans } from 'react-i18next';
import { Modal, Button } from '@hotjar/hotsauce';
import { createGlobalModal } from '@hotjar/webapp/features/GlobalModal/createGlobalModal';
import type { GlobalModalProps } from '@hotjar/webapp/features/GlobalModal/createGlobalModal';

export interface SegmentDeleteModalProps {
  segmentName: string;
}

export function SegmentDeleteModal({
  segmentName,
  onSubmit,
  onCancel,
}: SegmentDeleteModalProps & GlobalModalProps<void, void>): JSX.Element {
  const { t } = useTranslation();
  return (
    <Modal
      contentLabel={t('common:recordings.segment-edit-create.delete-segment.title')}
      isOpen
      onClose={onCancel}
      size="s"
    >
      <Modal.Header title={t('common:recordings.segment-edit-create.delete-segment.title')} />
      <Modal.Body>
        <Trans i18nKey="common:recordings.segment-edit-create.delete-segment.content">
          Deleting the segment <strong>{{ segmentName }}</strong> is permanent and can&apos;t be
          undone.
        </Trans>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => onCancel()} kind="ghost">
          {t('common:recordings.segment-edit-create.delete-segment.cancel')}
        </Button>
        <Button kind="danger" onClick={() => onSubmit()} type="submit">
          {t('common:recordings.segment-edit-create.delete-segment.submit')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export const openSegmentDeleteModal = createGlobalModal<SegmentDeleteModalProps, void, void>(
  SegmentDeleteModal,
);

export const showDeleteSegmentModal = async (
  title: string,
  onSubmit: () => void,
  onCancel: () => void,
): Promise<void> => {
  try {
    await openSegmentDeleteModal({ segmentName: title });
    onSubmit();
  } catch {
    onCancel();
  }
};
